import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

interface StepProgressProps {
  currentStep: number;
  fontSize?: 'sm' | 'base' | 'lg' | 'xl';
}

const fontSizeClasses = {
  sm: 'text-sm',
  base: 'text-base',
  lg: 'text-base md:text-lg',
  xl: 'text-lg md:text-xl'
} as const;

const indexFontSizeClasses = {
  sm: 'text-xs',
  base: 'text-sm',
  lg: 'text-sm md:text-base',
  xl: 'text-base md:text-lg'
} as const;

type Step = {
  key: string;
  label: string;
};

export function StepProgress({ currentStep, fontSize = 'sm' }: StepProgressProps) {
  const { t } = useTranslation('common');

  const steps: Step[] = [
    // { key: 'signIn', label: t('steps.signIn') },
    { key: 'checkout', label: t('steps.checkout') },
    { key: 'success', label: t('steps.success') },
    { key: 'activate', label: t('steps.activate') }
  ];

  return (
    <div className="flex items-center justify-center gap-0.5 md:gap-2 py-4 w-full max-w-md mx-auto px-4 lg:px-8 lg:max-w-none">
      {steps.map((step, index) => {
        const isActive = index + 1 === currentStep;
        const isPast = index + 1 < currentStep;

        return (
          <div key={step.key} className="flex items-center gap-0.5 md:gap-2">
            {index > 0 && (
              <div className={cn(
                "h-px w-4 md:w-12 mx-2 flex-grow",
                isActive ? 'bg-sky-200' :
                  isPast ? 'bg-sky-200' :
                    'bg-slate-200'
              )} />
            )}
            <div className="flex items-center">
              <div
                className={cn(
                  "flex items-center justify-center w-6 h-6 rounded-full font-semibold",
                  indexFontSizeClasses[fontSize],
                  isActive ? 'bg-sky-500 text-sky-50' :
                    isPast ? 'bg-sky-200 text-sky-50' :
                      'bg-slate-100 text-slate-600'
                )}
              >
                {index + 1}
              </div>
              <span
                className={cn(
                  "ml-1.5 md:ml-2",
                  fontSizeClasses[fontSize],
                  isActive ? 'text-sky-500 font-semibold' :
                    isPast ? 'text-sky-200 font-semibold' :
                      'text-slate-400'
                )}
              >
                {step.label}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}